import jwt_decode from "jwt-decode";
import { actions } from "../app/modules/Auth/_redux/authRedux";

import { env } from "../env";

const URL = `${env.REACT_APP_API_URL}`;

export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    (config) => {
      const {
        auth: { token },
      } = store.getState();

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    },
    (err) => Promise.reject(err)
  );

  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const {
        auth: { token, user },
      } = store.getState();

      const { config, response } = error;
      const UNAUTHORIZED = 401;
      const TOKEN_EXPIRED = "10008";
      const TOKEN_INVALID = "10009";
      if (
        (response.data.status === UNAUTHORIZED &&
          response.data.error === TOKEN_EXPIRED) ||
        (response.data.status === UNAUTHORIZED &&
          response.data.error === TOKEN_INVALID)
      ) {
        // Token expired, attempt to refresh the token
        try {
          const decoded = jwt_decode(token);
          const refreshToken = decoded.refresh_token;

          const result = await axios.get(
            `${URL}/api/User/RefreshToken?ID=${refreshToken}`
          );

          const accessToken = result.data.data.token;

          store.dispatch(actions.refreshToken(accessToken, user));
          config.headers.Authorization = `Bearer ${accessToken}`;

          // Retry the original request
          return axios.request(config);
        } catch (refreshError) {
          throw refreshError;
        }
      }
      throw error;
    }
  );
}
